import React, { PropTypes, Component } from 'react'
import CSSModules from 'react-css-modules'
import styles from './input-date-time-local.css'

/** A drop-in replacement for <input type=datetime-local /> that allows the keyboard to work.
 * The reason this is required is that if you use onChange on a datetime input, stash the
 * modified value somewhere, then propagate that value back to the datetime input's value
 * prop, the input element will reset the internal keyboard state of the DOM element
 * (i.e when you try and type 12:56, the values flicker around and never let you actually
 * type 12:56).
 *
 * Instead, this component keeps the value changes in its own local state, and then fires
 * off a props.onChange event when the control is blurred.
 */
export class InputDateTimeLocal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.data.value,
    }

    this.onBlur = (e) => {
      if (this.props.data.onChange) {
        this.props.data.onChange(e)
      }
    }

    this.onChange = (e) => {
      this.setState({
        value: e.target.value,
      })
    }
  }

  componentWillReceiveProps(props) {
    if (props.data.value !== null) {
      this.setState({
        value: props.data.value,
      })
    }
  }

  render() {
    return (
      <input
        {...this.props}
        onChange={this.onChange}
        onBlur={this.onBlur}
        type="datetime-local"
        value={this.state.value}
        styleName="inputdatetimelocal"
      />
    )
  }
}

InputDateTimeLocal.propTypes = {
  data: PropTypes.object,
}

export default CSSModules(InputDateTimeLocal, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/input-date-time-local/index.js
 **/